import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import QueryFilterCpt from './QueryFilterCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostListCustomerQueryPage } from '@/services/cms/customer';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt,
    QueryFilterCpt
  },
  data() {
    return {
      searchTypeValue: 'chnName',
      searchTypes: [{
        text: '客户姓名',
        value: 'chnName'
      }, {
        text: '客户号',
        value: 'customerNo'
      }, {
        text: '客户手机',
        value: 'mobile'
      }],
      searchForm: {
        chnName: undefined,
        customerNo: undefined,
        mobile: undefined
      },
      searchValue: undefined,
      btnLoading: false,
      listRequest: rqtPostListCustomerQueryPage,
      codeResItems: [{
        title: '客户重要性',
        dataIndex: 'importType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerImportType'
      }, {
        title: '客户级别',
        dataIndex: 'levelType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerLevelType'
      }],
      filterConditions: []
    };
  },
  computed: {
    searchFieldPh() {
      return '输入' + this.searchTypes.find(e => e.value === this.searchTypeValue).text;
    }
  },
  mounted() {
    this.initResCodeType(this.codeResItems);
  },
  methods: {
    onSearch() {
      this.btnLoading = true;
      for (const key in this.searchForm) {
        if (this.searchTypeValue === key) {
          this.searchForm[key] = this.searchValue;
        } else {
          this.searchForm[key] = undefined;
        }
      }
      this.attachFilter();
      this.$refs['ListViewCpt'].initListData();
    },
    onFilterClick() {
      this.$refs.QueryFilterCpt.showView();
    },
    onFilterChange(vals) {
      this.filterConditions = vals;
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    },
    attachFilter() {
      for (const item of this.filterConditions) {
        if (item.dataIndex) {
          this.searchForm[item.dataIndex] = item.value;
        }
      }
    },
    getStatusStyle(status) {
      let color = undefined;
      switch (status) {
        case '01':
          color = '#07c160';
          break;
        case '02':
          color = '#ee0a24';
          break;
        case '03':
          color = '#1989fa';
          break;
      }
      return color;
    }
  }
};